import React from 'react';
import { useLocation } from 'react-router-dom';
import AllPaymentsHistory from './AllPaymentsHistory';
import FaqWrapper from '../../common/FaqWrapper';

const PaymentsHistory = () => {
  const location = useLocation();
  const data = location.state?.paymentsHistoryData;

  return (
    <>
      <AllPaymentsHistory data={data} />
    </>
  );
};

export default FaqWrapper(PaymentsHistory);
